import React from "react";
import { ShoppingBag, Warehouse, Truck, PackageCheck } from "lucide-react";
import Reveal from "components/Reveal";
import SectionHeading from "components/SectionHeading";

const STEPS = [
  { icon: ShoppingBag, title: "Захиалга / Бүртгэл", desc: "Манай хаягаар захиалгаа хийж, илгээмжээ бүртгүүлнэ." },
  { icon: Warehouse, title: "Эрээн агуулах", desc: "Таны бараа Эрээн дэх агуулахад хүлээн авагдаж бүртгэгдэнэ." },
  { icon: Truck, title: "Тээвэрлэлт", desc: "Ачаа Говь-Алтай руу найдвартай, хурдан тээвэрлэгдэнэ." },
  { icon: PackageCheck, title: "Хүлээн авах", desc: "Хамгийн ойр салбараас эсвэл хүргэлтээр гардаж авна." },
];

const HowItWorks = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <Reveal>
          <SectionHeading
            eyebrow="Алхамууд"
            title="Хэрхэн ажилладаг вэ?"
            subtitle="Захиалгаас гар дээр тань хүртэл — энгийн 4 алхам"
          />
        </Reveal>

        {/* Алхмуудыг тасархай замаар холбоно: desktop-д хэвтээ, гар утсанд босоо */}
        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
          <div
            className="hidden md:block absolute top-8 left-[12.5%] right-[12.5%] border-t-2 border-dashed border-primary/40"
            aria-hidden="true"
          />
          {STEPS.map((s, i) => (
            <Reveal key={i} delay={i * 120}>
              <div className="relative flex md:flex-col items-start md:items-center gap-5 md:gap-0 md:text-center">
                {i < STEPS.length - 1 && (
                  <span
                    className="md:hidden absolute left-8 top-16 -bottom-8 border-l-2 border-dashed border-primary/40"
                    aria-hidden="true"
                  />
                )}
                <div className="relative w-16 h-16 rounded-full bg-white border-2 border-primary text-primary flex items-center justify-center shadow-lg shadow-primary/15 shrink-0">
                  <s.icon className="w-7 h-7" />
                  <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-brand-blue text-white text-[11px] font-bold flex items-center justify-center ring-2 ring-white">
                    {i + 1}
                  </span>
                </div>
                <div className="pt-1 md:pt-0 md:mt-5">
                  <h3 className="font-display font-bold text-foreground">{s.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed md:max-w-[15rem] md:mx-auto">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
